if (!customElements.get('quick-add-inline')) {
  customElements.define('quick-add-inline', class QuickAddInline extends HTMLElement {
    constructor() {
      super();
      this.setupDevice();
    }

    setupDevice() {
      const isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (!isMobile && this.querySelector('.quick-add-inline__desktop')) {
        this.loadDesktopHandler();
      }

      window.matchMedia('(max-width: 749px)').addEventListener('change', (e) => {
        if (!e.matches) {
          this.loadDesktopHandler();
        }
      });
    }

    async addToCart(variantId) {
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const cart = cartDrawer || cartNotification;

      if (cart) {
        formData.append(
          'sections',
          cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript, application/json'
        },
        body: formData
      };

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', config);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const responseData = await response.json();

        // Fire GTM event for Quick Add tracking
        if (typeof dataLayer !== 'undefined') {
          dataLayer.push({
            event: 'quick_add_click',
            event_category: 'ecommerce',
            event_action: 'quick_add',
            product_id: responseData.product_id,
            variant_id: variantId,
            product_title: responseData.product_title,
            price: responseData.price,
            source: 'quick-add-inline',
            page_type: window.theme.currentTemplate
          });
        }

        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'quick-add-inline',
            productVariantId: variantId,
            cartData: responseData,
          });
        }

        this.openCart(responseData);
        return responseData;
      } catch (error) {
        console.error('Error adding to cart:', error);
        throw error;
      }
    }

    openCart(response) {
      const cartDrawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');

      if (cartDrawer) {
        // Remove is-empty class before rendering - this prevents trapFocus errors
        if (cartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }

        cartDrawer.renderContents(response);
      } else if (cartNotification) {
        cartNotification.renderContents(response);
      }

      // Publish cart update event for other components
      if (window.Shopify && window.Shopify.cartUpdate) {
        window.Shopify.cartUpdate(response);
      }
    }

    openNotifyMe(variantId) {
      const notifyMeDrawer = document.querySelector('notify-me[data-notify-me-drawer]');
      if (!notifyMeDrawer) return;

      const productCard = this.closest('.card-wrapper, .product-card, [data-product-id]');
      if (!productCard) return;

      const productId = this.dataset.productId;
      const titleElement = productCard.querySelector('.card__heading a, .product-title, h3, .card__content .h3');
      const title = titleElement ? titleElement.textContent.trim() : 'Product';

      const sizeButtons = this.querySelectorAll('.quick-add-inline-desktop__size-btn');
      const variants = Array.from(sizeButtons).map(button => ({
        id: button.dataset.variantId,
        title: button.dataset.size,
        available: !button.classList.contains('quick-add-inline-desktop__size-btn--sold-out')
      }));

      const productData = {
        id: parseInt(productId),
        title: title,
        variants: variants
      };

      if (typeof notifyMeDrawer.openWithProduct === 'function') {
        notifyMeDrawer.openWithProduct(productData, variantId);
      }
    }

    loadDesktopHandler() {
      const buttons = this.querySelectorAll('.quick-add-inline-desktop__size-btn');

      buttons.forEach(button => {
        const newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);

        newButton.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Check if this is a notify-me button
          if (newButton.hasAttribute('data-notify-me-trigger')) {
            const variantId = newButton.dataset.variantIdNotify;
            this.openNotifyMe(variantId);
            return;
          }

          if (newButton.disabled) return;

          const variantId = newButton.dataset.variantId;
          const originalContent = newButton.innerHTML;

          newButton.classList.add('quick-add-inline-desktop__size-btn--loading');
          newButton.disabled = true;

          try {
            await this.addToCart(variantId);

            newButton.classList.remove('quick-add-inline-desktop__size-btn--loading');
            newButton.classList.add('quick-add-inline-desktop__size-btn--success');

            setTimeout(() => {
              newButton.classList.remove('quick-add-inline-desktop__size-btn--success');
              newButton.disabled = false;
            }, 1000);

          } catch (error) {
            newButton.classList.remove('quick-add-inline-desktop__size-btn--loading');
            newButton.disabled = false;
            newButton.innerHTML = originalContent;
            console.error('Failed to add to cart:', error);
          }
        });
      });
    }
  });
}